import axios from 'axios'

export default function (context, val) {
    let id, cId,cName, cType,cLegalId,cLegalName,CarryOverOfFunds, callback = () => {
    };
    if (typeof val === 'string') id = val;
    else {
        id = val.id;
        cId = val.cId ? val.cId : null;
        cName = val.cName ? val.cName : null;
        cLegalId = val.cLegalId ? val.cLegalId : null;
        cLegalName = val.cLegalName ? val.cLegalName : null;
        cType = val.cType ? val.cType : null;
        CarryOverOfFunds = val.CarryOverOfFunds ? val.CarryOverOfFunds : '';
        if (val.callback) callback = val.callback;
    }
    let ag = context.state.list.filter(i => {
        return i.code === id;
    })[0];
    if (ag) {
        if (ag.load) ag.callback.push(callback);
        else callback(context.getters.agreement(id));
        return;
    }
    context.commit('set_item', id);
    ag = context.state.list.filter(i => {
        return i.code === id;
    })[0];
    ag.CarryOverOfFunds = CarryOverOfFunds || '';
    axios({
        method: 'get',
        url: '/tourclient/payment/contractorPayments?Code=' + encodeURIComponent(ag.code) + '&_' + new Date().getTime(),
        requestId: 'tourclient/payment/contractorPayments/' + ag.code,
    }).then(result => {
        let data = result.data;
        if (!data) {
            window.app.$notify.error({
                message: 'Не удалось получить данные с сервера'
            });
            ag.callback.forEach(i => i(null));
            context.commit('remove_item', ag.code);
            callback(null);
            return;
        }
        if (data.PaymentsData.ResultQueryInfo && data.PaymentsData.ResultQueryInfo.HasError) {
            window.app.$notify.warning({
                message: data.PaymentsData.ResultQueryInfo.UserMessages,
            });
            context.commit('remove_item', ag.code);
            ag.callback.forEach(i => i(null));
            callback(null);
            return;
        }
        let contragent;
        let form = context.rootState.finances.pay.form;
        if (data.ClientContractorsData.IsPreorder) {
            window.app.$notify.warning({
                message: '№' + ag.code + ' является предзаказом и недоступен для оплаты',
            });
            ag.callback.forEach(i => i(null));
            context.commit('remove_item', ag.code);
            callback(null);
            return;
        }
        if (form.ContragentID && (!cId)) {
            switch (form.ContragentType) {
                case 1:
                    contragent = data.ClientContractorsData.Contragents.filter(i => {
                        return i.Id === form.ContragentID;
                    })[0];
                    break;
                case 2:
                    contragent = data.ClientPartnerContractorsData.Contragents.filter(i => {
                        return i.Id === form.ContragentID;
                    })[0];
                    break;
                case 3:
                    contragent = data.PartnerContractorsData.Contragents.filter(i => {
                        return i.Id === form.ContragentID && i.SelectedLegalEntityId === form.PartnerLegalEntityId;
                    })[0];
                    break;
                case 7:
                    contragent = data.ReservationCenterContractorsData.Contragents.filter(i => {
                        return i.Id === form.ContragentID && i.SelectedLegalEntityId === form.PartnerLegalEntityId;
                    })[0];
                    break;
            }
            if (!contragent) {
                window.app.$notify.warning({
                    message: ' В путёвке №' + ag.code + ' отсутствует контрагент ' + form.ContragentName,
                });
                context.commit('remove_item', ag.code);
                ag.callback.forEach(i => i(null));
                callback(null);
                return;
            }
        }
        if(cId){
            data.cId = cId;
            data.cName = cName;
            data.cLegalId = cLegalId;
            data.cLegalName = cLegalName;
            data.cType = cType;
        }
        context.commit('set_data', data);
        context.dispatch('finances/pay/agreement_push', ag, {root: true});
        context.dispatch('set_comment', context.getters.agreement(ag.code));
        let agreement = context.getters.agreement(id);
        context.dispatch('finances/pay/rates/get', ({
            date: agreement.date,
            c1: agreement.currency,
            c2: form.CurrencyId,
            callback: (rate) => {
                ag.course = +rate.course;
                ag.callback.forEach(i => i(context.getters.agreement(id)));
                callback(context.getters.agreement(id));
            }
        }), {root: true});
    }).catch(e => {
        context.dispatch('error', e, {root: true});
    });
}
